import { render } from "./PreviewSendStep.vue?vue&type=template&id=33d08582&scoped=true"
import script from "./PreviewSendStep.vue?vue&type=script&lang=js"
export * from "./PreviewSendStep.vue?vue&type=script&lang=js"

import "./PreviewSendStep.vue?vue&type=style&index=0&id=33d08582&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d08582"]])

export default __exports__